import { settings } from "../../kernel/Settings";
import { FuncResponse, FuncResponseType, FunctionBase, RunStreamResponse, } from "../../storyV2/function/FunctionBase";
import { FunctionUtil } from "../../storyV2/function/FunctionUtil";
export class ImageGenFunction extends FunctionBase {
    async run(input, identityInfo) {
        if (typeof input === "string") {
            const res = await this.requestStableai(input, identityInfo);
            return new FuncResponse(FuncResponseType.IMAGE_TEXT, res);
        }
        else {
            let edgeStreamResponse = {
                values: input,
                streamResponse: new RunStreamResponse(),
            };
            this.runBatch(input, edgeStreamResponse, identityInfo);
            return new FuncResponse(FuncResponseType.STRING_GROUP, edgeStreamResponse);
        }
    }
    async runBatch(input, edgeStreamResponse, identityInfo) {
        const map = new Map();
        const requests = input.map((value, index) => {
            const request = this.requestStableai(value, identityInfo).then(res => {
                map.set(index, res);
                let completion = false;
                if (map.size === input.length) {
                    completion = true;
                }
                edgeStreamResponse.streamResponse.receive(map, completion);
                return Promise.resolve();
            });
            return request;
        });
        return Promise.all(requests).then(() => {
            return Promise.resolve();
        });
    }
    async requestStableai(prompt, identityInfo) {
        const result = await this.brainClient.openAi.stableai(prompt, undefined, FunctionUtil.createAbortUuid(identityInfo));
        const s3url = result.data.s3_path || "";
        const url = `${settings.S3CDN}${encodeURI(s3url)}`;
        return url;
    }
}
